export default __webpack_public_path__ + "static/media/new-peoplekeep-lite-logo.d2b4ed18.svg";